export default "__VITE_ASSET__BZ37c9BH__"